import '../common/common.js';
import {AddToBasketApi} from "./AddToBasketApi.js";

window.o_order = window.o_order ?? {};
window.o_order.api = window.o_order.api ?? {};

if (!window.o_order.api.initialized) {
  window.o_order.api.initialized = true;

  window.o_global.eventQBus.onModuleLoaded(
    'ft1.order-core.api',
    ['ft1.order-core.common-public'],
    () => new AddToBasketApi().init()
  );
}